import { Edge } from '@xyflow/react';

import { ContactFlowAction, ContactFlowActionsSummary } from '../../domain';
import { ContactFlowNode, ContactFlowNodes } from './Nodes';

export function actionsToNodesAndEdges(actions: ContactFlowAction[]): { nodes: ContactFlowNode[]; edges: Edge[] } {
  return {
    nodes: actions.map(({ id, type, description, parameter, next }) => ({
      id,
      // fallback to default node if not a ContactFlowNode
      ...(type in ContactFlowNodes && { type }),
      data: {
        type,
        description,
        parameter: Object.entries(parameter ?? {}).reduce((p, [k, v]) => (v ? { ...p, [k]: v } : p), {}),
        sourceHandles: next?.routes.map(({ selector }, i) => ({
          handleId: `${id}-${i}`,
          selector,
        })),
      },
      position: { x: 0, y: 0 },
    })),
    edges: actions.flatMap(({ id: source, next }) =>
      (next?.routes || []).map(({ actionId: target }, i) => {
        const sourceHandle = `${source}-${i}`;
        return {
          id: `${sourceHandle}-${target}`,
          source,
          target,
          sourceHandle,
        };
      }),
    ),
  };
}

export function nodesAndEdgesToActions(nodes: ContactFlowNode[], edges: Edge[]): ContactFlowActionsSummary {
  return {
    actions: nodes.slice(1).map(({ id, data: { type, parameter, description = '', sourceHandles } }) => ({
      id,
      type,
      description,
      parameter,
      next: sourceHandles && {
        routes: sourceHandles.map(({ handleId, selector }) => ({
          actionId: edges.find((e) => e.sourceHandle === handleId)?.target ?? '',
          selector,
        })),
      },
    })),
    startActionId: edges.find(({ source }) => source === nodes[0].id)?.target ?? '',
  };
}
